import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Form, Row, Col, Modal } from "react-bootstrap";
import "./SubcontractorInvoice.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, ToastMessage, LoadingSpinner } from '../../components'
import ItemList from '../../containers/ItemList/ItemList'
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS, MISTO, NATUREZAPEDIDO } from '../../utils/constants';

function SubcontractorInvoice(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
    
    const orderList                       = useSelector(state => state.orderList);
    const selectedOrder                   = useSelector(state => state.orders.selectedOrder);
    const isLoading                       = useSelector(state => state.subcontractor.isLoading);
    const isLoadingById                   = useSelector(state => state.subcontractor.isLoadingById);
    const fetchedSubcontractorInvoice     = useSelector(state => state.subcontractor.fetchedSubcontractorInvoiceDetails);
    const subcontractorList               = useSelector(state => state.subcontractor.providerSubcontractorList);
    const editInvoiceId                   = useSelector(state => state.subcontractor.editInvoiceId);
    const subcontractorInvoiceByOrderList = useSelector(state => state.subcontractor.subcontractorInvoiceByOrderList);

	const pageMessages = messages[lang].subcontractorInvoicePage

    const subcontractorToast = useSelector(state => state.subcontractor.subcontractorToast);

    const [disableForm,    setDisableForm]    = useState(false);
    const [showNextButton, setShowNextButton] = useState(true);
    const [showToast,      setShowToast]      = useState(false);
    const [messageError,   setMessageError]   = useState('');
    const [messageType,    setMessageType]    = useState('toast-success');    	
    const [validated,      setValidated]      = useState(false);

    const [providerOptions, setProviderOptions] = useState([
        {id: '1', message: ''},
    ]);

    const [disableNextButton, setDisableNextButton] = useState(true);
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    
    const [formFields, setFormFields] = useState({
        id: '',
        dataNotaFiscalRetorno: '',
        numeroNotaFiscalRetorno: '',
        dataNotaFiscalSaida: '',
        numeroNotaFiscalSaida: '',
        quantidadePecasRetorno: '',
        quantidadePecasSaida: '',
        pedido: '',
        fornecedor: '',
        subcontratado: ''
    });  

    const [showModal, setShowModal] = useState(false);
        
	const pageBack = () => {
		props.history.push(`/main`);
    };

    const mappedInvoiceList = () => {
        if (subcontractorInvoiceByOrderList.length === 0) {
            return []
        }

        return subcontractorInvoiceByOrderList.map((item) => {
            return [                  
                    { 
                        text: item.subcontratado && item.subcontratado.nomeFantasia ? item.subcontratado.nomeFantasia : '',
                        maxLength: 4000
                    },
                    { 
                        text: item.numeroNotaFiscalSaida ? item.numeroNotaFiscalSaida : '',
                        maxLength: 4000
                    },
                    { 
                        text: item.numeroNotaFiscalRetorno ? item.numeroNotaFiscalRetorno : '',
                        maxLength: 4000
                    },
                    {
						text: <i className="icon-pen" />,
                        onClick: () => {
                            editInvoiceModal(item.id)
						},
					},
                    {
						text: <i className="icon-remove" />,
                        onClick: () => {
                            deleteInvoiceModal(item.id)
						},
					}
                ]
        });
    }

    const header = [       
        pageMessages.subcontratado,
        pageMessages.notaFiscalSaida,
        pageMessages.notaFiscalRetorno,
        pageMessages.detalhes,
        pageMessages.excluir,
    ];

    const [isEdit, setIsEdit] = useState(false);
    const [showDeleteOption, setShowDeleteOption] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;

        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity()) {
            if (isEdit) {
                dispatch({
                    type: 'EDIT_SUBCONTRACTOR_INVOICE',
                    payload: formFields
                })
            } else {
                dispatch({
                    type: 'CREATE_NEW_SUBCONTRACTOR_INVOICE',
                    payload: formFields
                })
            }
        }

        setValidated(true);
    };

    const deleteInvoice = (event) => {
        dispatch({
            type: 'DELETE_SUBCONTRACTOR_INVOICE',
            payload: formFields
        })
    };

    const nextStep = () => {
        let order = orderList[0] ? orderList[0] : selectedOrder.data

        if((order.sustentabilidade === ALGODAO_BCI || order.sustentabilidade === DEMAIS_ATRIBUTOS_SUSTENTAVEIS || order.sustentabilidade === MISTO) && 
            (order.empresa.exigirCertSustentabilidade) &&
            (order.naturezaPedido === NATUREZAPEDIDO.NORMAL || order.naturezaPedido === NATUREZAPEDIDO.IMPORTADO)) {
            props.history.push(`/sustainability`);
        }else {
            if (order.fornecedor.exigirDeclProdutor && order.empresa.exigirDeclProdutor && order.naturezaPedido === NATUREZAPEDIDO.NORMAL) {
                props.history.push('/producer-declaration');
            } else {
                props.history.push('/reconcile');
            }
        }
    };

    const disableNewInvoiceButton = () => {
        let order = orderList[0] ? orderList[0] : selectedOrder.data

        let conciliacaos = order.conciliacaos[order.conciliacaos.length - 1]

        if (conciliacaos && conciliacaos.statusConciliacaoComercial.id === '2' && conciliacaos.statusConciliacaoFiscal.id === '2') {
            return true
        }     
        
        return false
    };

    const newInvoiceModal = () => {
        setShowDeleteOption(false)
        setProviderOptions([
            {
                id: orderList[0] ? orderList[0].fornecedor.id : selectedOrder.data.fornecedor.id,
                message: orderList[0] ? orderList[0].fornecedor.nome : selectedOrder.data.fornecedor.nome,
            }
        ])
        setShowModal(true)
        setIsEdit(false)
        setFormFields({         
            id: '',
            dataNotaFiscalRetorno: '',
            numeroNotaFiscalRetorno: '',
            dataNotaFiscalSaida: '',
            numeroNotaFiscalSaida: '',
            quantidadePecasRetorno: '',
            quantidadePecasSaida: '',
            pedido: orderList[0] ? orderList[0].id : selectedOrder.data.id,
            fornecedor: orderList[0] ? orderList[0].fornecedor.id : selectedOrder.data.fornecedor.id,
            subcontratado: subcontractorList[0].id
        })
    }

    const editInvoiceModal = (invoiceId) => {
        setShowDeleteOption(false)
        setShowModal(true)
        setIsEdit(true)
        dispatch({
            type: 'GET_SUBCONTRACTOR_INVOICE_BY_ID',
            payload: {
                id: invoiceId
            }
        })
    }

    const deleteInvoiceModal = (invoiceId) => {
        setShowDeleteOption(true)
        setShowModal(true)
        setIsEdit(true)        
        dispatch({
            type: 'GET_SUBCONTRACTOR_INVOICE_BY_ID',
            payload: {
                id: invoiceId
            }
        })
    }

    useEffect(() => {
        setShowToast(subcontractorToast.showToast)
        setMessageError(subcontractorToast.message)
        setMessageType(subcontractorToast.messageType)

        if (subcontractorToast.message === messages[lang].registerSuccess || subcontractorToast.message === messages[lang].deleteSuccess) {
            setShowModal(false)
            let order = orderList[0] ? orderList[0] : selectedOrder.data

            dispatch({
                type: 'GET_ORDER_SUBCONTRACTOR_INVOICE_LIST',
                payload: {
                    idPedido: order.id,
                    idFornecedor: order.fornecedor.id
                }
            })

            setValidated(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subcontractorToast]);

    useEffect(() => {	
        if (subcontractorInvoiceByOrderList.length > 0) {
            setDisableNextButton(false)
        } else {
            setDisableNextButton(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subcontractorInvoiceByOrderList]);

    useEffect(() => {	
        if (editInvoiceId) {
            setFormFields({ ...formFields, id: editInvoiceId })
            setIsEdit(true)

            dispatch({
                type: 'SET_EDIT_INVOICE_ID',
                payload: null
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [editInvoiceId]);
   
    useEffect(() => {
        setShowToast(false)

        let fromPage = props.history.location.from

        setShowNextButton(orderList[0] && fromPage !== '/order-options' ? true : false)

        let order = orderList[0] ? orderList[0] : selectedOrder.data

        let conciliacaos = order.conciliacaos[order.conciliacaos.length - 1]

        if (conciliacaos && conciliacaos.statusConciliacaoComercial.id === '2' && conciliacaos.statusConciliacaoFiscal.id === '2') {
            setDisableForm(true)
            setDisableSaveButton(true)
        }

        dispatch({
            type: 'GET_ORDER_SUBCONTRACTOR_INVOICE_LIST',
            payload: {
                idPedido: order.id,
                idFornecedor: order.fornecedor.id
            }
        })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        if (fetchedSubcontractorInvoice && fetchedSubcontractorInvoice.id) {
            setDisableNextButton(false)

            setProviderOptions([
                {
                    id: fetchedSubcontractorInvoice.fornecedor.id,
                    message: fetchedSubcontractorInvoice.fornecedor.nome
                }
            ])
    
            setIsEdit(true)
            setFormFields({
                id: fetchedSubcontractorInvoice.id,
                dataNotaFiscalRetorno: fetchedSubcontractorInvoice.dataNotaFiscalRetorno ? fetchedSubcontractorInvoice.dataNotaFiscalRetorno : '',
                numeroNotaFiscalRetorno: fetchedSubcontractorInvoice.numeroNotaFiscalRetorno ? fetchedSubcontractorInvoice.numeroNotaFiscalRetorno : '',
                dataNotaFiscalSaida: fetchedSubcontractorInvoice.dataNotaFiscalSaida,
                numeroNotaFiscalSaida: fetchedSubcontractorInvoice.numeroNotaFiscalSaida, 
                quantidadePecasRetorno: fetchedSubcontractorInvoice.quantidadePecasRetorno ? fetchedSubcontractorInvoice.quantidadePecasRetorno : '', 
                quantidadePecasSaida: fetchedSubcontractorInvoice.quantidadePecasSaida, 
                pedido: fetchedSubcontractorInvoice.pedido.id, 
                fornecedor: fetchedSubcontractorInvoice.fornecedor.id, 
                subcontratado: fetchedSubcontractorInvoice.subcontratado.id,
            })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchedSubcontractorInvoice]);

    const rightButtons = disabled => () =>
    <>
        {
            showNextButton ?
            <ButtonStandard
            id="norm_save_button"
            text={messages[lang].next}
            textClass="text-2"
            isLoading={isLoading}
            disabled={disableNextButton}
            className="btn btn-primary btn-save btn-light"
            onClick={nextStep}            
            />
            :
            null
        }
        
    </>

    const leftButtons = disabled => () =>
    <>
        <ButtonStandard
            id="new_invoice_button"
            text={pageMessages.cadastrarNovaNota}
            textClass="text-2"
            isLoading={isLoading}
            disabled={disabled || subcontractorList.length === 0 || isLoadingById || disableNewInvoiceButton()}
            className="btn btn-primary btn-save btn-light"
            onClick={() => newInvoiceModal()}    
        />
    </>

	return (
		<div className="subcontractor-invoice-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={pageMessages.titulo}
			/>

            <div>
                <Container className="pt-3 justify-content-start">
                    <Row className="mt-1">
                        <ItemList
                            header={header}
                            titleTable={`Notas Fiscais de Subcontratado para o Pedido ${orderList[0] ? orderList[0].id : selectedOrder.data.id}`}
                            isLoading={isLoading}
                            isEmpty={subcontractorInvoiceByOrderList.length === 0}
                            listTable={mappedInvoiceList()}
                        />
                    </Row>
                </Container>
                <Modal
                    show={showModal}
                    onHide={() => { setShowModal(false) }}
                    aria-labelledby="contained-modal-title-vcenter"
                    className="conciliation-history-result-modal"
                    centered
                >	
                    <Modal.Header className="text-left" closeButton>
                        <Modal.Title className="w-100 font-weight-bold">
                            {showDeleteOption ? pageMessages.confirmarExclusao : pageMessages.cadastroNotaFiscal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container className="px-0 mb-0 pb-0">
                            {
                                isLoadingById
                                ?
                                    <div className="loader">
                                        <LoadingSpinner />
                                    </div>
                                :
                                null
                            }
                            <Form noValidate validated={validated} className="px-3" onSubmit={handleSubmit}>
                                <Row>
                                    <Form.Group as={Col} xs={12} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.subcontratado}</Form.Label>
        
                                        <Form.Control
                                            required
                                            as="select"
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.subcontratado}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, subcontratado: event.target.value },
                                            )}
                                        >
                                            {
                                                subcontractorList.map(value => (
                                                    <option key={value.id} value={value.id}>{value.nomeFantasia}</option>
                                                ))
                                            } 
                                        </Form.Control>
        
                                        <Form.Control.Feedback type="invalid">
                                            {messages[lang].requiredField}
                                        </Form.Control.Feedback>
        
                                    </Form.Group>
                                </Row>
    
                                <Row>
                                    <Form.Group as={Col} xs={4} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.dataNotaFiscalSaida}</Form.Label>
        
                                        <Form.Control
                                            type="date"
                                            required
                                            className="text-2 border-radius-full"
                                            value={formFields.dataNotaFiscalSaida}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, dataNotaFiscalSaida: event.target.value },
                                            )}
                                            />
        
                                        <Form.Control.Feedback type="invalid">
                                            {messages[lang].requiredField}
                                        </Form.Control.Feedback>
        
                                    </Form.Group>
        
                                    <Form.Group as={Col} xs={4} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.numeroNotaFiscalSaida}</Form.Label>
        
                                        <Form.Control
                                            required
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.numeroNotaFiscalSaida}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, numeroNotaFiscalSaida: event.target.value },
                                            )}
                                            />
        
                                        <Form.Control.Feedback type="invalid">
                                            {messages[lang].requiredField}
                                        </Form.Control.Feedback>
                                    </Form.Group>
        
                                    <Form.Group as={Col} xs={4} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.quantidadePecasSaida}</Form.Label>
        
                                        <Form.Control
                                            required
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.quantidadePecasSaida}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, quantidadePecasSaida: event.target.value },
                                            )}
                                            />
        
                                        <Form.Control.Feedback type="invalid">
                                            {messages[lang].requiredField}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
    
                                <Row>
                                    <Form.Group as={Col} xs={4} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.dataNotaFiscalRetorno}</Form.Label>
        
                                        <Form.Control
                                            type="date"
                                            className="text-2 border-radius-full"
                                            value={formFields.dataNotaFiscalRetorno}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, dataNotaFiscalRetorno: event.target.value },
                                            )}
                                            />
                                    </Form.Group>
        
                                    <Form.Group as={Col} xs={4} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.numeroNotaFiscalRetorno}</Form.Label>
        
                                        <Form.Control
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.numeroNotaFiscalRetorno}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, numeroNotaFiscalRetorno: event.target.value },
                                            )}
                                            />
                                    </Form.Group>
        
                                    <Form.Group as={Col} xs={4} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.quantidadePecasRetorno}</Form.Label>
        
                                        <Form.Control
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.quantidadePecasRetorno}
                                            disabled={disableForm || isLoadingById || showDeleteOption}
                                            onChange={event => setFormFields(
                                                { ...formFields, quantidadePecasRetorno: event.target.value },
                                            )}
                                            />
                                    </Form.Group>
                                </Row>
    
                                <Row>
                                    <Form.Group as={Col} xs={6} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.pedido}</Form.Label>
        
                                        <Form.Control
                                            required
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.pedido}
                                            disabled={true}
                                            onChange={event => setFormFields(
                                                { ...formFields, pedido: event.target.value },
                                            )}
                                            />
        
                                        <Form.Control.Feedback type="invalid">
                                            {messages[lang].requiredField}
                                        </Form.Control.Feedback>
        
                                    </Form.Group>
        
                                    <Form.Group as={Col} xs={6} className="mt-1">
                                        <Form.Label className="text-2">{pageMessages.fornecedor}</Form.Label>
        
                                        <Form.Control
                                            required
                                            as="select"
                                            className="text-2 border-radius-full"
                                            type="text"
                                            value={formFields.fornecedor}
                                            disabled={true}
                                            onChange={event => setFormFields(
                                                { ...formFields, fornecedor: event.target.value },
                                            )}
                                        >
                                            {
                                                providerOptions.map(value => (
                                                    <option key={value.message} value={value.id}>{value.message}</option>
                                                ))
                                            } 
                                        </Form.Control>
        
                                        <Form.Control.Feedback type="invalid">
                                            {messages[lang].requiredField}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                {
                                    !showDeleteOption
                                    ?
                                    <Container style={{textAlign: 'center'}} className="px-0 mb-0 pb-0">
                                        <ButtonStandard
                                            id="norm_save_button"
                                            type="submit"
                                            text={messages[lang].save}
                                            textClass="text-2"
                                            isLoading={isLoading}
                                            disabled={disableSaveButton || disableForm || isLoadingById}
                                            className="btn-primary btn-sm btn-standard px-2 mr-2"
                                        />
                                    </Container>
                                    :
                                    null
                                }

                            </Form>
                            {
                                showDeleteOption
                                ?
                                <Container style={{textAlign: 'center'}} className="px-0 mb-0 pb-0">
                                    <ButtonStandard
                                        id="norm_save_button"
                                        type="submit"
                                        text={pageMessages.excluir}
                                        textClass="text-2"
                                        isLoading={isLoading}
                                        disabled={disableSaveButton || disableForm || isLoadingById}
                                        className="btn-primary btn-sm btn-standard px-2 mr-2"
                                        onClick={() => deleteInvoice()}
                                    />
                                </Container>
                                :
                                null
                            }                
                        </Container>
                    </Modal.Body>
                </Modal>
                 <FooterActions
                        ButtonGroupLeft={leftButtons(false)}
                        ButtonGroupRight={rightButtons(isLoading)}/>
            </div>               
		</div>
	)
}

export default withRouter(SubcontractorInvoice);